<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col sm="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.userdata.list.filters.userdata') }}:</label>
            <input v-model.lazy="filters.userdata" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col sm="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.userdata.list.filters.name') }}:</label>
            <input v-model.lazy="filters.name" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col sm="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.userdata.list.filters.surname') }}:</label>
            <input v-model.lazy="filters.surname" v-debounce="delay" class="form-control" type="text" placeholder="">
          </div>
        </b-col>
        <b-col sm="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.userdata.form.idClientType') }}:</label>
            <model-select :options="clientTypesOptions" v-model="filters.idClientType"></model-select>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.userdata.list.filters.state') }}:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="filters.state"
                :options="radioOptions"
                buttons
                button-variant="outline-primary"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label>{{ $t('views.firm.form.tags') }}:</label>
            <multi-select @select="onSelectTag" :options="tagOptions" :selected-options="tagsFilter"></multi-select>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label>{{ $t('views.firm.form.withoutTags') }}:</label>
            <multi-select @select="onSelectWithoutTag" :options="tagOptions" :selected-options="withoutTagsFilter"></multi-select>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
import ApiService from '@/utils/ApiService'
import { ModelSelect, MultiSelect } from 'vue-search-select'
export default {
  name: 'UserDataFiltering',
  components: {
    ModelSelect, MultiSelect
  },
  data () {
    return {
      radioOptions: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      delay: 500,
      filters: {
        userdata: '',
        name: '',
        surname: '',
        state: 1,
        'userDataTags.idTag': [],
        userDataWithoutTag: []
      },
      statuses: [],
      clientTypesOptions: [],
      tagOptions: [],
      tagsFilter: [],
      withoutTagsFilter: [],
      loading: false,
      routeName: null
    }
  },

  directives: {
    debounce
  },

  watch: {
    filters: {
      deep: true,
      handler () {
        this.$emit('addToSearchParams', this.filters)
      }
    }
  },

  created () {
    this.routeName = this.$route.name
    this.getClientTypes()
    this.fetchTagOptions()
  },

  methods: {
    async getClientTypes () {
      let params = { pagination: false }
      const response = await new ApiService('client_types', params).getResults()
      this.clientTypesOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
      this.clientTypesOptions.unshift({
        text: this.$t('global.notSet'),
        value: null
      })
    },
    async fetchTagOptions () {
      let params = { pagination: false, tagType: 2 }
      const response = await new ApiService('e_x_c_m_tags', params).getResults()
      this.tagOptions = response.items.map(tag => {
        return {
          value: tag['@id'],
          text: tag.tag
        }
      })
    },
    onSelectTag (items, lastSelectItem) {
      this.tagsFilter = items
      this.filters['userDataTags.idTag'] = items.map(item => {
        return item.value
      })
      this.lastSelectItem = lastSelectItem
    },
    onSelectWithoutTag (items, lastSelectItem) {
      this.withoutTagsFilter = items
      this.filters['userDataWithoutTag'] = items.map(item => {
        return item.value
      })
      this.lastSelectItem = lastSelectItem
    }
  }
}
</script>
